// extracted by mini-css-extract-plugin
export default {"cardContainer":"CustomCard_cardContainer__3nlRf","card_content":"CustomCard_card_content__Fek7y"};